import { useState, useEffect } from 'react';
import { getEvaluatorsByUserId } from '@/services/database';
import { Evaluator } from '@/types/evaluator';
import { useAuth } from '@/contexts/AuthContext';

export function useEvaluators() {
  const { currentUser } = useAuth();
  const [evaluators, setEvaluators] = useState<Evaluator[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadEvaluators();
  }, [currentUser]);

  const loadEvaluators = async () => {
    if (!currentUser) return;

    try {
      const evaluatorsList = await getEvaluatorsByUserId(currentUser.uid);
      setEvaluators(evaluatorsList);
    } catch (error) {
      console.error('Error loading evaluators:', error);
      setError('Failed to load evaluators');
    } finally {
      setLoading(false);
    }
  };

  return {
    evaluators,
    setEvaluators,
    loading,
    error,
    setError
  };
}